import { render } from "./HealthForm.vue?vue&type=template&id=75250e7f&scoped=true"
import script from "./HealthForm.vue?vue&type=script&lang=ts"
export * from "./HealthForm.vue?vue&type=script&lang=ts"

import "./HealthForm.vue?vue&type=style&index=0&id=75250e7f&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-75250e7f"

export default script